import React from "react";
import CapRow from "../../CapRow";
import CapIcon from "../../CapIcon";
import { rootClsPrefix as clsPrefix } from "../constants";

const ErrorBar = ({ textError }) => {
  return (
    <CapRow
      className={`${clsPrefix}-error-bar`}
      type="flex"
      align="middle"
      justify="center"
    >
      <CapIcon type="alert-red" data-testid="cap-icon" />
      <span>{textError}</span>
    </CapRow>
  );
};

export default ErrorBar;